import KunLoading97 from './src/index'

KunLoading97.install = function (Vue) {
	Vue.component(KunLoading97.name, KunLoading97);
}

export default KunLoading97;
